import React from 'react';
import { formatDate } from '@/utils/dateHelper';
import SimpleCell from '@/components/table/SimpleCell';

const DataManagementValidationDateCell = ({ lastValidationDate }) => (
  <SimpleCell content={lastValidationDate && formatDate(lastValidationDate)} />
);

export default DataManagementValidationDateCell;
